module.exports = __webpack_public_path__ + "static/media/1_14.d4f01c5e.png";